export class RetailExperienceUserModel {
    userId: string;
    username: string;
}